import { z } from 'zod'

/**
 * ログイン中の利用者自身の情報（テナントではなく人に紐づくもの）。
 *
 * 通常の利用者と運営の両方が使う。お試し（暫定テナント）には利用者のレコードが無いので返らない。
 */
export const AccountSchema = z.object({
  /** ログイン用メールアドレス */
  loginEmail: z.string(),
  /** 通知先として設定したメールアドレス。null ならログイン用に届く */
  notificationEmail: z.string().nullable(),
  /** 確認メールを送って、リンクが開かれるのを待っているメールアドレス */
  pendingNotificationEmail: z.string().nullable(),
})
export type Account = z.infer<typeof AccountSchema>

export const RequestNotificationEmailChangeInputSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'メールアドレスを入力してください')
    .max(255, 'メールアドレスが長すぎます')
    .email('メールアドレスの形式が正しくありません'),
})
export type RequestNotificationEmailChangeInput = z.infer<
  typeof RequestNotificationEmailChangeInputSchema
>

export const ConfirmNotificationEmailInputSchema = z.object({
  token: z.string().min(1).max(128),
})
export type ConfirmNotificationEmailInput = z.infer<typeof ConfirmNotificationEmailInputSchema>

export const ConfirmNotificationEmailOutputSchema = z.object({
  /** 切り替え後に通知が届くメールアドレス */
  notificationEmail: z.string(),
})
export type ConfirmNotificationEmailOutput = z.infer<typeof ConfirmNotificationEmailOutputSchema>
